import React from 'react';
import * as Styles from './AlertsBell.styles';
import { IconBell } from 'gatorcomponents';
import { useSelector } from 'react-redux';

const AlertsBell = () => {
  const { diagnosticAlerts } = useSelector(state => state.alertsV2);

  const alerts = [...diagnosticAlerts];
  const unreadedAlertsAmount = alerts.filter(alert => alert.isNew).length;

  return (
    <Styles.Wrapper data-testid="menu">
      {!!unreadedAlertsAmount && (
        <Styles.NotificationsCircle data-testid="notifications-circle">
          {unreadedAlertsAmount}
        </Styles.NotificationsCircle>
      )}
      <IconBell />
    </Styles.Wrapper>
  );
};

export default AlertsBell;
